import Component from "vue-class-component";

// IMPORTANT: This file needs to imported before any components are loaded otherwise the hooks won't be registered
// for those components

// Register the router hooks with their names so that they can be used in components
Component.registerHooks(["beforeRouteEnter", "beforeRouteLeave", "beforeRouteUpdate"]);
